import { Route } from '@angular/router';
import { SolutionDatatableType } from '@app/src/app/modules/solution/classes/default/datatable/solution.datatable.type';
import { SolutionCategoryDatatableType } from '@app/src/app/modules/solution/classes/category/datatable/solution.category.datatable.type';
import { DashboardGlobalConfigType } from '@ckmk/angular';
import { SolutionGuard } from '@app/src/app/modules/solution/classes/default/guard/solution-guard';
import { SolutionCategoryGuard } from '@app/src/app/modules/solution/classes/category/guard/solution-category-guard';

export default (config: DashboardGlobalConfigType): Route => ({
  path: 'solutions',
  providers: [SolutionDatatableType, SolutionCategoryDatatableType],
  children: [
    {
      path: '',
      redirectTo: 'list',
      pathMatch: 'full',
    },
    {
      path: 'list',
      loadComponent: () =>
        import('@app/src/app/modules/solution/views/admin/default/solution-list/solution-list.component').then(
          (m) => m.SolutionListComponent,
        ),
      data: {
        permissions: ['PERMISSION_READ_SOLUTION'],
      },
    },
    {
      path: 'show/:solution',
      loadComponent: () =>
        import('@app/src/app/modules/solution/views/admin/default/solution-show/solution-show.component').then(
          (m) => m.SolutionShowComponent,
        ),
      data: {
        permissions: ['PERMISSION_READ_SOLUTION'],
      },
      canActivate: [SolutionGuard(config)],
    },
    {
      path: 'create',
      loadComponent: () =>
        import('@app/src/app/modules/solution/views/admin/default/solution-manage/solution-manage.component').then(
          (m) => m.SolutionManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_CREATE_SOLUTION'],
      },
    },
    {
      path: 'update/:solution',
      loadComponent: () =>
        import('@app/src/app/modules/solution/views/admin/default/solution-manage/solution-manage.component').then(
          (m) => m.SolutionManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_UPDATE_SOLUTION'],
      },
      canActivate: [SolutionGuard(config)],
    },
    {
      path: 'copy/:solution',
      loadComponent: () =>
        import('@app/src/app/modules/solution/views/admin/default/solution-manage/solution-manage.component').then(
          (m) => m.SolutionManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_COPY_SOLUTION'],
      },
      canActivate: [SolutionGuard(config)],
    },
    {
      path: 'categories',
      children: [
        {
          path: '',
          redirectTo: 'list',
          pathMatch: 'full',
        },
        {
          path: 'list',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/admin/category/category-list/solution-category-list.component').then(
              (m) => m.SolutionCategoryListComponent,
            ),
          data: {
            permissions: ['PERMISSION_READ_SOLUTION_CATEGORY'],
          },
        },
        {
          path: 'show/:category',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/admin/category/category-show/solution-category-show.component').then(
              (m) => m.SolutionCategoryShowComponent,
            ),
          data: {
            permissions: ['PERMISSION_READ_SOLUTION_CATEGORY'],
          },
          canActivate: [SolutionCategoryGuard(config)],
        },
        {
          path: 'create',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/admin/category/category-manage/solution-category-manage.component').then(
              (m) => m.SolutionCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_CREATE_SOLUTION_CATEGORY'],
          },
        },
        {
          path: 'update/:category',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/admin/category/category-manage/solution-category-manage.component').then(
              (m) => m.SolutionCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_UPDATE_SOLUTION_CATEGORY'],
          },
          canActivate: [SolutionCategoryGuard(config)],
        },
        {
          path: 'copy/:category',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/admin/category/category-manage/solution-category-manage.component').then(
              (m) => m.SolutionCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_COPY_SOLUTION_CATEGORY'],
          },
          canActivate: [SolutionCategoryGuard(config)],
        },
        {
          path: '**',
          redirectTo: 'list',
          pathMatch: 'full',
        },
      ],
    },
    {
      path: '**',
      redirectTo: 'list',
      pathMatch: 'full',
    },
  ],
});
